import {WalkthroughDefinition} from '../types';

export const SURVEYS_TOUR_TARGETS = {
  title: 'surveys.title',
  overview: 'surveys.overview',
  configure: 'surveys.configure',
} as const;

export const companySurveysWalkthrough: WalkthroughDefinition = {
  id: 'companySurveys',
  version: 1,
  steps: [
    {
      target: SURVEYS_TOUR_TARGETS.title,
      titleKey: 'walkthrough.surveys.welcome.title',
      bodyKey: 'walkthrough.surveys.welcome.body',
      placement: 'bottom-start',
    },
    {
      target: SURVEYS_TOUR_TARGETS.overview,
      titleKey: 'walkthrough.surveys.overview.title',
      bodyKey: 'walkthrough.surveys.overview.body',
      placement: 'bottom',
    },
    {
      target: SURVEYS_TOUR_TARGETS.configure,
      titleKey: 'walkthrough.surveys.configure.title',
      bodyKey: 'walkthrough.surveys.configure.body',
      placement: 'top',
    },
  ],
};
